import { FreeGameModelBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist"

export class FreeGameModel extends FreeGameModelBehavior {
//
constructor(serverModel:any){
    super(serverModel);
    this.setAnimationSequence(["stackSymbol", "showAllFrames", "fgBigWin", "retriggeringAnimation", "doNextSpinInFreeGame"]);
}
getIsFgBigWin(winAmount?: number): boolean {
    let win = this.getCurrentWinAmt();
    if (winAmount !== undefined) {
        win = winAmount;
    }
    const currBet = this.serverModel.getCurrentTotalBet();
    if (win > currBet * SlotConstantsBehavior.WINTICKUP_THRESHOLDS[0]) {
        return true;
    }
}
}

